import React, {Component} from 'react';
import {
  Row,
  Col
} from 'reactstrap';

import Link from 'react-router-dom/NavLink';

import Button from '../../../shared/components/Button';
import SearchableDataTable from '../../../shared/components/SearchableDataTable';
import DropdownButton from '../../../shared/components/DropdownButton';

import { 
  alphabeticallySort,
  textContains
} from '../../../shared/utils';

class AccountBrandList extends Component {
  render(){
    const { brands, updateBrand } = this.props;

    return (
      <div>
        <Row>
          <Col xs='12'>
            <SearchableDataTable 
              items={brands}
              searchPromptText='Search by name'
              emptyText='This account has no brands linked to it'
              columns={[
                {
                  display:'logo',
                  name:'logoURL',
                  width:10,
                  renderCell:(item) => (
                    <div className={!item.active ? 'deactivated' : ''}>
                      {item.logoURL ? (
                        <img
                          style={{ height:50 }}
                          src={item.logoURL}
                          alt={`Logo for brand ${item.name}`}
                        />
                      ) : (
                        <span>N/A</span>
                      )}
                    </div>
                  )
                },{
                  display:'brand',
                  name:'name',
                  width:60,
                  sortFunc:(a,b) => alphabeticallySort(a.name,b.name),
                  filterFunc:(a,searchParam) => textContains(a.name,searchParam),
                  renderCell:(item) => (
                    <div className={!item.active ? 'deactivated' : ''}>
                      <Link to={`/superadmin/brands/${item.id}/edit`}>{item.name}</Link>
                    </div>
                  )
                },{
                  display:'experiences',
                  name:'totalCampaigns',
                  width:20,
                  sortFunc:(a,b) => b.totalCampaigns - a.totalCampaigns,
                  renderCell:(item) => (
                    <div className={!item.active ? 'deactivated' : ''}>
                      <span>{item.totalCampaigns}</span>
                    </div>
                  )
                },{
                  width:20,
                  renderCell:(item) => (
                    <div className='pull-right'>
                      <Button
                        size='sm'
                        linkHref={`/superadmin/brands/${item.id}/edit`}
                        textColor='#666666'
                        borderColor='#cccccc'
                        backgroundColor='#fff'
                      >
                        Edit
                      </Button> 
                      &nbsp;&nbsp;
                      <DropdownButton 
                        options={[
                          {
                            text:item.active ? 'Deactivate' : 'Activate', 
                            onClick:() => updateBrand(item.id,{active:!item.active})
                          }
                        ]} 
                      />
                    </div>  
                  )
                }
              ]}
            />
            <br />
            <br />
            <br />
          </Col>
        </Row>
      </div>
    )
  }
}

export default AccountBrandList;



// WEBPACK FOOTER //
// ./src/routes/AccountBrandList/components/AccountBrandList.js